<ngx-spinner bdColor = "rgba(0, 0, 0, 0.3)" size = "large" color = "#354052" type = "ball-clip-rotate" [fullScreen] = "true"></ngx-spinner>
<ns-brand-bar *ngIf="userInfo" [showComment]="true" [userInfo]="userInfo" [navigationServiceURL]="navigationServiceURL" [logoutURL]="logoutURL"></ns-brand-bar>
<router-outlet></router-outlet>
